import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout/layout.js";
import { Link } from 'gatsby';
import SEO from '../components/seo';
import ContactForm from '../components/forms/contactform.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Contact" mdxType="SEO" />
    <ContactForm mdxType="ContactForm" />
    <div className="container is-fluid">
      <h1>Our Locations</h1>
      <h3>Hyderabad</h3>
      <div className="content is-small">
        <p>
Plot No. 18, Level 2, iLabs Centre, Oval Building, <br />
Madhapur, Hitech City, Hyderabad 500081 <br />
Telangana, India
        </p>
        <p> E-mail: <a style={{
            textDecoration: 'none'
          }} href="mailto:info@technovature.com?Subject=Hello" target="_top">info@technovature.com </a> </p>
        <p> Phone: <a style={{
            textDecoration: 'none'
          }} href="tel:7013175234">+91 7013175234 </a> </p>
      </div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      